<template>
  <div>
    <!-- 全部订单的搜索面板 -->
    <el-card class="box-search-card"
             shadow="nerver">
      <div v-show="activeFirst"
           class="booking-header-system">
        <div class="booking-filter-area">
          下单日期：
          <el-date-picker class="content-input"
                          size="mini"
                          v-model="dateSelectorRange"
                          type="daterange"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          value-format="yyyy-MM-dd"
                          :default-time="['00:00:00', '23:59:59']"></el-date-picker>
          <div class="booking-search">
            <el-input size="mini"
                      :clearable="true"
                      prefix-icon="el-icon-search"
                      v-model="query"
                      placeholder="搜索信息">
            </el-input>
            <el-button @click="searchBooking"
                       size="mini"
                       type="primary"
                       icon="el-icon-search"
                       plain>查询订单</el-button>
          </div>
        </div>
        <div class="booking-filter-area">
          活动日期：
          <el-date-picker class="content-input"
                          size="mini"
                          v-model="dateSelector"
                          type="date"
                          start-placeholder="开始月份"
                          end-placeholder="结束月份"
                          value-format="yyyy-MM-dd"></el-date-picker>
        </div>
        <div class="booking-filter-area">
          订单编号：
          <el-input style="width: 220px"
                    size="mini"
                    clearable
                    v-model="inputBookingNum"
                    placeholder="请输入订单编号">
          </el-input>
          <div class="booking-change-booking">未处理订单：{{ waitAccept }}</div>
        </div>
        <div class="booking-filter-area">
          平台编号：
          <el-input style="width: 220px"
                    size="mini"
                    clearable
                    v-model="inputOtaNum"
                    placeholder="请输入平台编号"></el-input>
          <div class="booking-change-booking">
            需要修改的订单：{{ changeBooking }}
          </div>
        </div>
        <div class="booking-filter-area">
          订单状态：
          <el-radio-group @change="changeRadio"
                          v-model="status_radio">
            <el-radio :label="0">全部</el-radio>
            <el-radio :label="3">等待出行</el-radio>
            <el-radio :label="2">已确认</el-radio>
            <el-radio :label="1">未处理</el-radio>
            <el-radio :label="6">需要修改</el-radio>
            <el-radio :label="4">已取消</el-radio>
          </el-radio-group>
          <div class="booking-wait-accept">
            最近未处理出行日期：{{ waitAcceptDate }}
          </div>
        </div>
      </div>
      <!-- 飞猪订单的搜索面板 -->
      <div v-show="activeSecond"
           class="booking-header-system">
        <div class="booking-filter-area">
          平台订单编号：
          <el-input style="width: 220px"
                    size="mini"
                    clearable
                    v-model="second_search_Ota_id"
                    placeholder="请输入平台编号"
                    @keyup.enter.native="second_InputOta_click"></el-input>
          <div class="booking-search">
            <!-- <el-input
              size="mini"
              :clearable="true"
              prefix-icon="el-icon-search"
              v-model="query"
              placeholder="请输入订单信息"
            ></el-input>-->
            <el-button @click="second_InputOta_click"
                       size="mini"
                       type="primary"
                       icon="el-icon-search"
                       plain>搜索
            </el-button>
          </div>
        </div>
      </div>
    </el-card>
    <!-- 列表 -->
    <el-card v-if="is_staff"
             shadow="nerver">
      <div style="width:auto;text-align:center;"> 请联系管理员获取权限</div>
    </el-card>
    <el-card v-else
             shadow="nerver">
      <el-tabs v-model="activeName"
               @tab-click="clickBookingListTab">
        <!-- ------------------系统订单------------------ -->
        <el-tab-pane label="入库订单"
                     name="first">
          <booking-list-template ref="booking_list_template"
                                 :listLoading="loading"
                                 :bookingListData="allSysBookingList"
                                 :page_account="total_system"
                                 :pagesize_system="pagesize_system"
                                 @selectBookingTraveller="selectBookingTraveller"
                                 @editBooking="reviseSysBooking"
                                 @dealWithBooking="dealWithSysBooking"
                                 @getVoucher="getVoucher"
                                 @handlePageChange_system="handlePageChange_system"></booking-list-template>
        </el-tab-pane>
        <!-- ------------------飞猪订单------------------ -->
        <el-tab-pane label="飞猪"
                     name="second">
          <ota-booking-list-template ref="fly_booking_list_template"
                                     :listLoading="loading"
                                     :bookingListData="flyPigBookingList"
                                     :page_account="total_ota"
                                     @selectBookingTraveller="selectBookingTraveller"
                                     @editBooking="reviseOtaBooking"
                                     @dealWithBooking="dealWithBooking"
                                     @getVoucher="getVoucher"
                                     @handlePageChange_ota="handlePageChange_ota_flypig"></ota-booking-list-template>
        </el-tab-pane>
        <!-- ------------------淘宝 tbw------------------ -->
        <el-tab-pane label="淘宝-万宁"
                     name="threed">
          <ota-booking-list-template ref="tbw_booking_list_template"
                                     :listLoading="loading"
                                     :bookingListData="tbwBookingListData"
                                     :page_account="total_ota"
                                     @selectBookingTraveller="selectBookingTraveller"
                                     @editBooking="reviseOtaBooking"
                                     @dealWithBooking="dealWithBooking"
                                     @getVoucher="getVoucher"
                                     @handlePageChange_ota="handlePageChange_ota_tbw"></ota-booking-list-template>
        </el-tab-pane>
        <!-- ------------------淘宝 tbd------------------ -->
        <el-tab-pane label="淘宝-大东海"
                     name="fourth">
          <ota-booking-list-template ref="tbd_booking_list_template"
                                     :listLoading="loading"
                                     :bookingListData="tbdBookingListData"
                                     :page_account="total_ota"
                                     @selectBookingTraveller="selectBookingTraveller"
                                     @editBooking="reviseOtaBooking"
                                     @dealWithBooking="dealWithBooking"
                                     @getVoucher="getVoucher"
                                     @handlePageChange_ota="handlePageChange_ota_tbd"></ota-booking-list-template>
        </el-tab-pane>

        <!-- -----------------未出行订单------------------ -->
        <el-tab-pane label="未出行订单"
                     name="zero">
          <el-table v-loading="loading"
                    :data="noTripData"
                    class="all-booking"
                    width="100%"
                    :header-cell-style="{ background: '#F5F7FA', color: '#606266' }">
            <el-table-column label=" 活动信息">
              <template slot-scope="activeinfo">
                <div style="font-size: 15px; font-weight: bold">
                  {{ activeinfo.row.title }}
                </div>
                <div style="font-size: 13px">
                  套餐：{{ activeinfo.row.package }}
                </div>
                <div style="font-size: 13px">
                  参加日期：{{ activeinfo.row.trip_start_date }}
                </div>
                <div style="font-size: 13px">
                  时间/场次：{{ activeinfo.row.trip_start_time }}
                </div>
              </template>
            </el-table-column>

            <el-table-column label=" 预定人信息"
                             width="160%">
              <template slot-scope="contactinfo">
                <div class="testdiv">
                  <div style="font-size: 12px">
                    联系人： {{ contactinfo.row.contact_name }}
                  </div>
                  <div style="font-size: 12px">
                    电话： {{ contactinfo.row.contact_phone }}
                  </div>
                  <div style="font-size: 12px">
                    人数：{{ contactinfo.row.num }}
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="订单信息"
                             width="250%">
              <template slot-scope="bookinginfo">
                <div style="font-size: 13px">
                  系统单号： {{ bookinginfo.row.booking_no }}
                </div>
                <div style="font-size: 13px">
                  平台单号： {{ bookinginfo.row.ota_no }}
                </div>
                <div style="font-size: 13px">
                  下单日期：{{ bookinginfo.row.created_date }}
                </div>
              </template>
            </el-table-column>

            <el-table-column label="订单状态"
                             width="100%"
                             align="center">
              <template slot-scope="statusinfo">
                <el-tag size="mini"
                        effect="light">{{
                  statusinfo.row.status
                  }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column label=" 操作"
                             align="center"
                             width="180">
              <template slot-scope="bookinginfo">
                <el-button-group style="margin-top: 5px">
                  <!-- ---------处理订单---------- -->
                  <el-button size="mini"
                             @click="dealWithBooking(bookinginfo.row.ota_no)"
                             type="primary"
                             icon="el-icon-message">处理</el-button>
                  <!-- ---------修改订单信息---------- -->
                  <el-button size="mini"
                             @click="reviseBooking(bookinginfo.row, dialogReviseBooking)"
                             type="primary"
                             icon="el-icon-document-copy">修改</el-button>
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-card>
    <!-- 列表结束 -->
    <!-- 修改订单信息  -->
    <revise-resveration ref="reviseResveration"
                        :sku_list="sku_list"
                        :spu_title="spu_title"
                        :ota_booking_id="ota_booking_id"
                        :spu_id="spu_id"
                        :sku_name="sku_name"
                        :showReviseBookingDialog.sync="showReviseBookingDialog"
                        @closedReviseBookingDialog="closedReviseBookingDialog">
    </revise-resveration>

    <!-- 确认单 抽屉 --->
    <el-drawer :withHeader="false"
               :visible.sync="drawerVoucher"
               :direction="direction"
               size="40%">
      <div style="height: 100%; padding-bottom: 200px; padding-top: 20px">
        <div>
          <div id="booking_confirm_image">
            <!-- 确认单的头部 -->
            <div class="v-header">
              <span v-html="voucherHeader"></span>
              <div v-show="voucherData"
                   id="operator-info-area">
                {{ operator.key }}:{{ operator.value }}
              </div>
              <div v-show="voucherData"
                   id="operator-info-area-triangle"></div>
            </div>
            <!-- 确认单的状态、编号、二维码 -->
            <!-- 行前通知 -->
            <!-- 确认单的具体信息（表格） -->
            <div v-if="voucherData == null"
                 class="no-data-voucher">
              订单未入库，请处理后查看
            </div>
            <el-table v-else
                      :show-header="status"
                      v-loading="loading"
                      :data="voucherData"
                      style="width: 95%; margin: 0 auto"
                      :cell-style="voucherStyle">
              <el-table-column prop="key"
                               width="190%"></el-table-column>
              <el-table-column prop="value">
                <template slot-scope="value">
                  <div v-html="value.row.value"></div>
                </template>
              </el-table-column>
            </el-table>
            <!-- 确认单Footer的注意事项 -->
            <div style="padding-bottom: 10px"
                 v-show="voucherData">
              <div class="footer-title">行前须知</div>
              <div class="voucher-footer">
                <span v-html="voucherFooter"></span>
                <div class="attentionArea"
                     v-show="this.refundInfo !=null">
                  <p class="ftw900">退改说明：</p>
                  <div class="choice_show_area">{{refundInfo}}</div>
                </div>
                <!-- 定位 -->
                <div v-show="this.poi_info"
                     style="width:20%">
                  <el-divider></el-divider>
                  <vue-qr :margin="5"
                          colorDark="#0f6ea3"
                          colorLight="#FFF"
                          :logoSrc="qrImageUrl"
                          :text="qrCode"
                          :size="150"></vue-qr>
                  <div>
                    <div style="text-align:center">扫码查看定位</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="padding-bottom: 65px"></div>
        </div>

        <!-- 确认单的生成pdf/图片，确认 -->
        <div class="drawer-voucher-footer-button">
          <el-button @click="bookingConfirmImage"
                     size="mini">生成图片</el-button>
          <el-button @click="copyConfirmation"
                     size="mini">复制确认信息</el-button>
        </div>
      </div>
    </el-drawer>
    <!-- 预定 - 处理 对话框 -->
    <el-dialog title="预定渠道列表"
               :visible.sync="dialogDealwithBooking">
      <el-table :data="operatorInfo">
        <el-table-column property="operator"
                         label="渠道名称"
                         width="150"></el-table-column>
        <el-table-column property="price"
                         label="渠道价格"
                         width="200"></el-table-column>
        <el-table-column property="dealwith"
                         label="预定"></el-table-column>
      </el-table>
      <div class="copy-button">
        <el-popover placement="top"
                    width="280"
                    v-model="visibleDelete">
          <p style="font-size: 12px">请确认该操作</p>
          <p style="font-size: 12px">并补充删除订单的原因：</p>
          <p style="margin-bottom: 5px; font-size: 12px">
            （删除后全部订单中不可见，飞猪订单中仍然可见）
          </p>
          <el-input resize="none"
                    type="textarea"
                    :rows="2"
                    placeholder="请输入删除原因"
                    v-model="deleteReasion"></el-input>
          <div style="text-align: right; margin-top: 10px">
            <el-button size="mini"
                       type="text"
                       @click="visibleDelete = false">取消</el-button>
            <el-button type="primary"
                       size="mini"
                       @click="submitDeleteAndComment">确定</el-button>
          </div>
          <el-button style="margin-right: 10px"
                     slot="reference"
                     size="mini"
                     type="danger">删除该订单</el-button>
        </el-popover>

        <el-button @click="copyInfor()"
                   size="mini"
                   type="success">复制预定信息</el-button>
      </div>
    </el-dialog>
    <!-- 添加出行人 -->
    <select-add-traveller ref="select_add_traveller"
                          :traveller_data="traveller_data"
                          :showSelectTraveller.sync="showSelectTraveller"></select-add-traveller>
    <!-- 弹出框结束 -->
  </div>
</template>

<!-- 选项卡 -->
<script>
import BookingDetail from './BookingDetail'
import ReviseResveration from '../booking/ReviseResveration'
import SelectAddTraveller from '../../components/booking/SelectAddTraveller'
import BookingListTemplate from '../../components/booking/BookingListTemplate'
import OtaBookingListTemplate from '../../components/booking/OtaBookingListTemplate'
import html2canvas from 'html2canvas'
import vueQr from 'vue-qr'
export default {
  name: 'Booking',
  components: {
    vueQr,
    'booking-detail': BookingDetail,
    'select-add-traveller': SelectAddTraveller,
    'booking-list-template': BookingListTemplate,
    'ota-booking-list-template': OtaBookingListTemplate,
    'revise-resveration': ReviseResveration,
  },
  data() {
    return {
      is_staff: true,
      // element ui配置
      direction: 'ltr',
      loading: true,
      activeFirst: true,
      activeSecond: false,
      // 查询条件
      inputBookingNum: '', // 系统单号
      inputOtaNum: '', // 搜索的平台单号
      status_radio: 0,
      activeName: 'first',
      query: '',
      //飞猪订单查询条件
      second_search_Ota_id: '',
      // 全部订单查询条件
      dateSelectorRange: [],
      dateSelector: '',
      // 列表数据
      waitAccept: 0, // 系统未处理订单
      waitAcceptDate: null, // 最近未处理日期
      changeBooking: 0, // 待修改的订单
      allSysBookingList: [{}, {}, {}, {}], // 系统订单
      flyPigBookingList: [], // 飞猪列表数据
      tbwBookingListData: [], // 淘宝万宁
      tbdBookingListData: [], // 淘宝大东海
      noTripData: [], // 未出行

      // 平台订单分页
      pagenum: 1, //ota当前页
      pagesize: 5, // ota每页数据条数
      total_ota: -1,
      // 系统订单分页
      pagenum_system: 1,
      pagesize_system: 5,
      total_system: -1,
      // 处理的订单
      dealWithBookingNum: '',
      operatorInfo: [],
      deleteReasion: '优化权重', // 删除订单的原因
      // 对话框和抽屉
      drawer: false,
      drawerVoucher: false,
      dialogReviseBooking: false,
      dialogDealwithBooking: false,
      visibleDelete: false,
      showReviseBookingDialog: false, // ota 修改订单的对话框
      // 确认单数据列表
      voucherData: [],
      get_no: '',
      voucher_no: '',
      voucherHeader: '',
      refundInfo: '',
      operator: '',
      voucherFooter: '',
      status: false,
      poi_info: null,
      qrImageUrl: '',
      qrCode: '',
      // 修改订单信息
      ota_booking_id: '',
      sku_list: [],
      spu_id: null,
      sku_id: null,
      spu_title: '',
      sku_name: '',
      // 出行人信息
      showSelectTraveller: false,
      traveller_data: [],
      information: '', // 订单信息
      confirmation: '', // 确认信息
      // 飞猪授权
      // current_ip: this.$ip,
      current_ip: 'http://121.196.53.21:9080',
    }
  },
  created() {
    // 判断张类型是否是员工
    // this.$http.get(`/user/get_user_type`).then((res) => {
    //   if (res.data.type == true) {
    //     this.is_staff = true
    //   } else {
    //     this.is_staff = false
    //     this.getOrderList()
    //   }
    // })
    this.is_staff = false
    this.getOrderList()
  },
  methods: {
    bookingConfirmImage() {
      let options = {
        allowTaint: false,
        backgroudColor: null,
        useCORS: true,
        // 下面解决当页面滚动之后生成图片出现白边问题
        // height: document.getElementById('booking_confirm_image').offsetHeight,
        // width: document.getElementById('booking_confirm_image').offsetWidth,
        height: document.getElementById('booking_confirm_image').scrollHeight,
        windowHeight: document.getElementById('booking_confirm_image')
          .scrollHeight,
        // windowWidth: document.body.scrollWidth,
        windowHeight: document.body.scrollHeight,
        scrollX: 0,
        scrollY: -window.pageYOffset,
        // x: 0,
        // y: 0,
        scale: 4, //
      }
      //
      //
      html2canvas(
        document.getElementById('booking_confirm_image'),
        options
      ).then((canvas) => {
        let image = canvas.toDataURL('image/png')
        // 下载图片
        this.fileDownload(image)
      })
    },
    // 下载图片
    fileDownload(downloadUrl) {
      let aLink = document.createElement('a')
      aLink.style.display = 'none'
      aLink.href = downloadUrl
      aLink.download = '确认单.png'
      // 触发点击-然后移除
      document.body.appendChild(aLink)
      aLink.click()
      document.body.removeChild(aLink)
    },
    changeRadio() {
      console.log(this.status_radio)
    },
    //  -----------------------------------  公共方法  --------------------------------------
    // 检查字符串是否为空
    checkEmpty(str) {
      var res = str
      if (res == '' || res == undefined || res == null) {
        return ''
      } else {
        return res
      }
    },

    // ota用 ｜｜获取产品信息,用于完善表单
    getProductInfor(outer_sku_id) {
      console.log('通过外部套餐id，获取产品信息')
      return new Promise((resolve, reject) => {
        this.$http
          .get(`/product/get_product?outer_sku_id=${outer_sku_id}`)
          .then((res) => {
            // console.log(res.data.data.skus);
            const { data, errno, errmsg } = res.data
            if (errno == '0') {
              this.sku_list = data.skus // 添加套餐
              this.spu_id = data.id
              this.spu_title = data.spu_name
              data.skus.forEach((item, index) => {
                if (item.out_sku_id == outer_sku_id) {
                  // console.log("产品信息模版 out_sku_id");
                  // console.log(item);
                  // --------判断套餐是否有规格--------
                  if (item.price_type) {
                    let type_dict = new Function('return ' + item.price_type)()
                    this.$refs.reviseResveration.price_type_list = type_dict
                  }
                  // --------判断套餐是否有 附加项--------
                  this.$refs.reviseResveration.sku_additions_list =
                    item.sku_additions
                  // --------判断是否有 场次--------
                  this.$refs.reviseResveration.sku_times = []
                  let sku_times = []
                  let more_info_dict = new Function(
                    'return ' + item.more_info
                  )()
                  if (more_info_dict) {
                    if (more_info_dict.key == 'round') {
                      for (let info_time of more_info_dict.round) {
                        let value = {
                          value: info_time,
                        }
                        sku_times.push(value)
                      }
                      // this.$refs.reviseResveration.sku_times = sku_times;
                    }
                  }
                  this.$refs.reviseResveration.sku_times = sku_times
                  // --------判断套餐附加的预定信息--------

                  if (item.trip_res_template) {
                    this.$http
                      .get(
                        `/get_reservation_stencil?id=${item.trip_res_template}`
                      )
                      .then((res) => {
                        const { data, errmsg, errno } = res.data
                        let information_template = new Function(
                          'return ' + data[0].template
                        )()
                        this.$refs.reviseResveration.template_items =
                          information_template
                      })
                  } else {
                    // 否则模版为空
                    this.$refs.reviseResveration.template_items = []
                  }
                }
              })
              resolve(res)
            } else {
              resolve(res)
              return // 如果有编号，但是无法匹配，则继续执行下面的获取订单信息
            }
          })
      })
    },

    // 通过订单编号 booking_id 系统id，通过sku_id获取套餐选项,获取产品信息
    getProductInforBookingId(booking_id, sku_id) {
      return new Promise((resolve, reject) => {
        //
        this.$http
          .get(`/product/get_product?bookingID=${booking_id}`)
          .then((res) => {
            const { data, errmsg, errno } = res.data
            if (errno === '4004') {
              this.$message.error(errmsg)
              return
            } else if (errno === '4002') {
              this.$message.error(errmsg)
              return
            } else if (errno === '0') {
              // console.log("执行判断");
              this.sku_list = data.skus
              this.spu_id = data.id
              this.spu_title = data.spu_name
              // 附加项 和 预定信息的 补充
              // 初始化 表单的 属性
              for (let i of data.skus) {
                if (i.sku_id == sku_id) {
                  // console.log("产品信息模版 booking_id");
                  // console.log(i);
                  // --------判断套餐是否有规格--------
                  if (i.price_type) {
                    let type_dict = new Function('return ' + i.price_type)()
                    this.price_type_list = type_dict
                  }
                  // --------判断套餐是否有 附加项--------
                  this.$refs.reviseResveration.sku_additions_list =
                    i.sku_additions
                  // --------判断是否有 场次--------
                  this.$refs.reviseResveration.sku_times = []
                  let sku_times = []
                  let more_info_dict = new Function('return ' + i.more_info)()
                  if (more_info_dict) {
                    if (more_info_dict.key == 'round') {
                      for (let info_time of more_info_dict.round) {
                        let value = {
                          value: info_time,
                        }
                        sku_times.push(value)
                      }
                      // this.$refs.reviseResveration.sku_times = sku_times;
                    }
                  }
                  this.$refs.reviseResveration.sku_times = sku_times
                  // --------判断套餐附加行程 信息--------
                  if (i.trip_res_template) {
                    this.$http
                      .get(`/get_reservation_stencil?id=${i.trip_res_template}`)
                      .then((res) => {
                        const { data, errmsg, errno } = res.data
                        let information_template = new Function(
                          'return ' + data[0].template
                        )()
                        this.$refs.reviseResveration.template_items =
                          information_template
                      })
                  } else {
                    this.$refs.reviseResveration.template_items = []
                  }
                }
              }
            }
            resolve(res)
          })
      })
    },

    // 系统订单信息，填充表单数据 item => id
    getBookingInformation(id, api) {
      // this.$refs.reviseResveration.loading = true;
      return new Promise((resolve, reject) => {
        this.$http.get(`booking/detail?${api}=${id}`).then((res) => {
          console.log(res)
          const { data, errno, errmsg } = res.data
          if (errno == '4002') {
            this.$notify.error({
              title: '注意',
              duration: 0,
              message: errmsg,
            })
          } else if (errno == '4101') {
            this.$notify.error({
              title: '集市宝授权已过期',
              duration: 0,
              dangerouslyUseHTMLString: true,
              message: `<strong>点击获取授权：<a href="https://www.jishibao.top/#/dashboard
" style="color: blue；text-decoration:underline">👉【点此授权】</a></strong>`,
            })
            this.$refs.reviseResveration.loading = true
          } else if (errno == '0') {
            this.$refs.reviseResveration.voucher_id =
              data.about_booking.voucher_id

            this.spu_title = data.about_booking.spu_name
            this.sku_name = data.about_booking.sku_name
            this.spu_id = data.about_booking.spu_id
            this.sku_id = data.about_booking.sku_id
            // 出发日期
            this.$refs.reviseResveration.choiceDate =
              data.about_booking.trip_start_date_stamp
            // 出行日期
            if (data.about_booking.start_time != null) {
              this.$refs.reviseResveration.$refs.TimeInput.time =
                data.about_booking.start_time
            }

            // 选择的套餐id
            this.$refs.reviseResveration.selectPkgId = data.about_booking.sku_id
            this.sku_id = data.about_booking.sku_id

            // 处理附加项，附加项已有值：
            // console.log(this.$refs.reviseResveration.sku_additions_list);
            let sku_additions_list =
              this.$refs.reviseResveration.sku_additions_list
            // 订单的附加项内容
            let booking_additions = data.about_booking.select_addition_dict
            console.log('订单的附加项内容：')
            console.log(booking_additions)
            // forEach()：循环数组中的没一个，并放到参数函数中处理

            // sku_additions_list.forEach((item, index) => {
            //   let _obj = booking_additions.find((v) => {
            //     return v.addition_name == item.addition_name;
            //   });

            //   if (_obj) {
            //     sku_additions_list[index].isChecked = _obj.isChecked;
            //     sku_additions_list[index].addition_num = _obj.addition_num;
            //   }
            // });

            // 重新赋值sku_additions_list
            this.$refs.reviseResveration.sku_additions_list = booking_additions

            // data.about_booking.additional_info;
            this.$refs.reviseResveration.template_items =
              data.about_booking.additional_info

            // 规格与数量
            this.$refs.reviseResveration.price_type_list =
              data.about_booking.num
            // 联系人 电话 邮箱
            this.$refs.reviseResveration.inputContact = data.about_contact.name
            this.$refs.reviseResveration.inputPhone = data.about_contact.mobile
            this.$refs.reviseResveration.inputEmail = data.about_contact.emial
            // 平台、单号、备注
            this.$refs.reviseResveration.inputSource =
              data.about_booking.ota_source
            this.$refs.reviseResveration.inputBookingNum =
              data.about_booking.ota_id
            this.$refs.reviseResveration.inputBookingRemark =
              data.about_booking.remark
            resolve(res)
          }
        })
      })
    },
    // 获取 特定格式的 订单的预定信息，用于预定等
    async getFormedBookingInfo() {
      const res = await this.$http.get(
        `/booking/detail?booking_id=${this.dealWithBookingNum}`
      )
      const { data, errmsg, errno } = res.data
      // 订单信息
      console.log(res)
      if (errno == '0') {
        // 订单编号
        let information_id = '订单编号：' + data.about_booking.ota_id + '\n'
        // 出行日期
        let information_date =
          '出行日期：' + data.about_booking.trip_start_date + '\n'
        // 套餐名称
        let information_title =
          '套餐名称：' + data.about_booking.sku_name + '\n'
        // 场次
        let information_time =
          '场次/时间：' + this.checkEmpty(data.about_booking.start_time) + '\n'

        // 判断 订单信息 是否为空 -》 处理订单信息
        let pick_is_null = this.checkEmpty(data.about_booking.additional_info)
        let addition_info = ''
        if (pick_is_null) {
          let addition_list = []
          pick_is_null.forEach((item, index) => {
            let i = item.name + '：' + item.value + '\n'
            addition_list.push(i)
          })
          addition_info = addition_list.join('')
        } else {
          addition_info = ''
        }

        // 判断人数是否为空 -》 处理人数
        let information_num = this.checkEmpty(data.about_booking.num)
        let num_list = []
        if (information_num.length > 0) {
          information_num.forEach((item, index) => {
            let i = item.type + '：' + item.num + '\n'
            num_list.push(i)
          })
        }
        let num_info = num_list.join('')

        // 判断附加项是否为空 -》 处理 附加项
        let select_addition_dict = this.checkEmpty(
          data.about_booking.select_addition_dict
        )
        let select_addition_info = ''
        if (select_addition_dict) {
          let select_addition_list = []
          select_addition_dict.forEach((item, index) => {
            let i = item.addition_name + '：' + item.addition_num + '\n'
            select_addition_list.push(i)
          })
          select_addition_info =
            '------附加项------' + '\n' + select_addition_list.join('')
        } else {
          select_addition_info = ''
        }

        // 联系人
        let information_other =
          '联系人姓名：' +
          data.about_contact.name +
          '\n' +
          '联系电话：' +
          data.about_contact.mobile +
          '\n'

        // 出行人信息：
        let information_travellers = '--------' + '\n' + '\n'
        data.travellers.forEach((i, index) => {
          information_travellers =
            information_travellers +
            '出行人信息【' +
            (index + 1) +
            '】：' +
            '\n'
          // -------------证件-------------
          i.credential.forEach((item, index) => {
            if (item.credential != null) {
              information_travellers =
                information_travellers +
                item.credential +
                ':' +
                item.credentialNum +
                '\n'
            }
          })
          // 姓名
          if (i.name == null) {
            information_travellers = information_travellers + i.name + '\n'
          } else {
            information_travellers = information_travellers + '姓名：' + i.name
          }
          // 年龄
          if (i.age == null) {
            information_travellers = information_travellers
          } else {
            information_travellers = information_travellers + '年龄：' + i.age
          }
          // 生日
          if (i.borthday == null) {
            information_travellers = information_travellers
          } else {
            information_travellers =
              information_travellers + '生日：' + i.borthday + '\n'
          }
          // 出生地
          if (i.borth_location == null) {
            information_travellers = information_travellers
          } else {
            information_travellers =
              information_travellers + '出生地：' + i.borth_location + '\n'
          }
          // 邮箱
          if (i.email == null) {
            information_travellers = information_travellers + '\n'
          } else {
            information_travellers =
              information_travellers + '邮箱：' + i.email + '\n'
          }
          // 性别
          if (i.gender == null) {
            information_travellers = information_travellers + i.gender
          } else {
            if (i.gender == 1) {
              information_travellers =
                information_travellers + '性别：男' + '\n'
            } else if (i.gender == 0) {
              information_travellers =
                information_travellers + '性别：女' + '\n'
            }
          }
          // 身高
          if (i.height == null) {
            information_travellers = information_travellers + i.height
          } else {
            information_travellers =
              information_travellers + '身高：' + i.height + '\n'
          }

          // 体重
          if (i.weight == null) {
            information_travellers = information_travellers + i.weight
          } else {
            information_travellers =
              information_travellers + '体重：' + i.weight + '\n'
          }
          // 手机
          if (i.phone == null) {
            information_travellers = information_travellers + i.phone
          } else {
            information_travellers =
              information_travellers + '手机：' + i.phone + '\n'
          }

          // 所在地
          if (i.location == null) {
            information_travellers = information_travellers + i.location
          } else {
            information_travellers =
              information_travellers + '所在地：' + i.location + '\n'
          }

          information_travellers = information_travellers + '\n'
        })
        // 汇总
        this.information =
          information_id +
          information_date +
          information_title +
          information_time +
          num_info +
          information_other +
          addition_info +
          select_addition_info +
          information_travellers
        // 复制订单信息
        // console.log("生成订单信息");
        return this.information
      } else if (errno == '4002') {
        this.$notify({
          title: '警告',
          message: '该订单还未入库，请先入库',
          type: 'warning',
        })
      }
    },
    //  -----------------------------------  订单筛选  --------------------------------------

    // 飞猪订单列表的 筛选 查询按钮
    second_InputOta_click() {
      if (this.second_search_Ota_id == '') {
        // console.log(this.second_search_Ota_id);
        this.getFlyBookingList()
      } else {
        this.$http
          .get(`/booking/flypig/list?ota_no=${this.second_search_Ota_id}`)
          .then((res) => {
            console.log(res)
            // console.log(this.second_search_Ota_id);

            const { data, errmsg, errno } = res.data
            if (errno == '4002') {
              this.flyPigBookingList = []
            } else {
              this.flyPigBookingList.length = 0
              this.flyPigBookingList.push(data)
              // console.log(data);
              this.total = data.page_account
            }
          })
      }
    },
    // 待参加 订单列表的方法
    noTripList() {
      // 格式化方法
      Date.prototype.format = function (fmt) {
        var o = {
          'M+': this.getMonth() + 1, //月份
          'd+': this.getDate(), //日
          'h+': this.getHours(), //小时
          'm+': this.getMinutes(), //分
          's+': this.getSeconds(), //秒
          'q+': Math.floor((this.getMonth() + 3) / 3), //季度
          S: this.getMilliseconds(), //毫秒
        }
        if (/(y+)/.test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            (this.getFullYear() + '').substr(4 - RegExp.$1.length)
          )
        }
        for (var k in o) {
          if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(
              RegExp.$1,
              RegExp.$1.length == 1
                ? o[k]
                : ('00' + o[k]).substr(('' + o[k]).length)
            )
          }
        }
        return fmt
      }
      // 提供当前日期和时间，后台拆分后做对比
      this.pagenum_system = 1
      this.pagesize_system = 15
      let nowDate = new Date().format('yyyy-MM-dd') // 获取当前日期
      // console.log(nowDate);
      let nowTime = new Date().format('hh:mm:ss') // 获取当前时间
      // console.log(nowTime);

      this.$http
        .get(
          `/booking/no_start_trip?td=${nowDate}&td_time=${nowTime}&voucher_no=${this.inputBookingNum}&ota_no=${this.inputOtaNum}&page_number=${this.pagenum_system}&page_size=${this.pagesize_system}`
        )
        .then((res) => {
          const { data, errmsg, errno } = res.data
          this.noTripData = data.booking
          this.total_system = data.page_account
        })
    },
    // 搜索订单按钮 搜索条件的查询按钮 ,根据条件查询
    searchBooking() {
      // 拼接 链接，发送请求，更新数据
      this.loading = true
      this.activeFirst = true
      this.pagenum_system = 1
      this.pagesize_system = 5
      if (this.dateSelectorRange == 0 || this.dateSelectorRange == null) {
        this.dateSelectorRange = []
      }
      if (this.dateSelector == 0 || this.dateSelector == null) {
        this.dateSelector = ''
      }

      let sd = this.dateSelectorRange[0]
      if (sd == undefined) {
        sd = ''
      }
      let ed = this.dateSelectorRange[1]
      if (ed == undefined) {
        ed = ''
      }
      let td = this.dateSelector

      this.$http
        .get(
          `/booking/list?status=${this.status_radio}&sd=${sd}&ed=${ed}&td=${td}&voucher_no=${this.inputBookingNum}&ota_no=${this.inputOtaNum}&page_number=${this.pagenum_system}&page_size=${this.pagesize_system}`
        )
        .then((res) => {
          const { data, errmsg, errno } = res.data
          console.log(res)
          if (errno == '0') {
            this.waitAccept = data.wait_accept
            this.waitAcceptDate = data.wait_accept_near_date
            this.changeBooking = data.change_booking
            this.allSysBookingList = data.booking
            this.total_system = data.item_account
            this.loading = false
          } else if (errno == '4103') {
            this.$notify({
              title: ' 注意',
              message: errmsg,
              type: 'warning',
            })
          }
        })
    },
    //  -----------------------------------  切换 订单列表（系统、飞猪） 分页 --------------------------------------
    // 列表 表头切换 需要执行的方法
    clickBookingListTab(tab) {
      if (tab.name == 'first') {
        this.$refs.booking_list_template.pagenum_system = 1
        this.getOrderList()
        this.status_radio = 0
        this.activeFirst = true
        this.activeSecond = false
      } else if (tab.name == 'second') {
        this.$refs.fly_booking_list_template.pagenum_system = 1
        this.getFlyBookingList()
        this.activeFirst = false
        this.activeSecond = true
      } else if (tab.name == 'threed') {
        this.$refs.tbw_booking_list_template.pagenum_system = 1
        this.getTbwBookingList()
        this.activeFirst = false
        this.activeSecond = false
        this.page_num = 1
      } else if (tab.name == 'fourth') {
        this.$refs.tbd_booking_list_template.pagenum_system = 1
        this.getTbdBookingList()
        this.activeFirst = false
        this.activeSecond = false
        this.page_num = 1
      }
    },

    // 获取 系统订单  及 分页
    getOrderList() {
      this.loading = true
      this.$http
        .get(
          `/booking/list?page_number=${this.pagenum_system}&page_size=${this.pagesize_system}`
        )
        .then((res) => {
          const { data, errmsg, errno } = res.data
          // console.log(res);
          if (errno === '0') {
            this.waitAccept = data.wait_accept
            this.waitAcceptDate = data.wait_accept_near_date

            this.changeBooking = data.change_booking
            this.allSysBookingList = data.booking
            this.total_system = data.item_account
            this.loading = false
          } else {
            this.$notify.error({
              title: '警告',
              message: errmsg,
              type: 'warning',
            })
          }
        })
    },
    handlePageChange_system(val) {
      // console.log(`每页 ${val} 条`);
      this.loading = true
      let sd = this.dateSelectorRange[0]
      if (sd == undefined) {
        sd = ''
      }
      let ed = this.dateSelectorRange[1]
      if (ed == undefined) {
        ed = ''
      }
      let td = this.dateSelector
      this.$http
        .get(
          `/booking/list?status=${this.status_radio}&page_number=${val}&page_size=${this.pagesize_system}&sd=${sd}&ed=${ed}&td=${td}&voucher_no=${this.inputBookingNum}&ota_no=${this.inputOtaNum}`
        )
        .then((res) => {
          const { data, errmsg, errno } = res.data
          this.waitAccept = data.wait_accept
          this.waitAcceptDate = data.wait_accept_near_date
          this.changeBooking = data.change_booking
          this.allSysBookingList = data.booking
          this.total_system = data.item_account
          this.loading = false
        })
    },

    // 获取 飞猪订单列表  及 分页
    getFlyBookingList() {
      // 参数：当前页码：page_no、  每个页面的 数量：page_size
      // /list/flypig?page_no=1&page_size=4
      this.loading = true
      this.$http
        .get(
          `booking/flypig/list?ota_no=${this.inputOtaNum}&query=${this.query}&page_no=${this.pagenum}&page_size=${this.pagesize}`
        )
        .then((res) => {
          console.log(res)
          // 解构
          const { data, total, errno, errmsg } = res.data

          if (errno === '0') {
            this.flyPigBookingList = data
            this.total_ota = total
          } else if (errno == '4101') {
            this.$router.push({ path: '/login' })
            this.$message.warning(errmsg)
          } else if (errno == '4102') {
            // 飞猪授权通知
            this.$notify.error({
              title: '飞猪授权已过期',
              duration: 0,
              dangerouslyUseHTMLString: true,
              message: `<strong>点击获取授权：<a href="${data}${this.current_ip}/booking/auth&view=web
" style="color: blue；text-decoration:underline">👉【点此授权】</a></strong>`,
            })
            // 获取到 后台的 json 信息, 转移到
          } else {
            this.$message.warning(errmsg)
          }
          this.loading = false
        })
    },
    handlePageChange_ota_flypig(val) {
      this.loading = true
      this.$http
        .get(
          `/booking/flypig/list?ota_no=${this.inputOtaNum}&query=${this.query}&page_no=${val}&page_size=${this.pagesize}`
        )
        .then((res) => {
          // 解构
          const { data, total, errno, errmsg } = res.data

          if (errno === '0') {
            this.flyPigBookingList = data
            this.total_ota = total
          } else if (errno == '4101') {
            this.$router.push({ path: '/login' })
            this.$message.warning(errmsg)
          } else if (errno == '4102') {
            // 飞猪授权通知
            this.$notify.error({
              title: '飞猪授权已过期',
              duration: 0,
              dangerouslyUseHTMLString: true,
              message: `<strong>点击获取授权：<a href="${data}${this.current_ip}/booking/auth&view=web
" style="color: blue；text-decoration:underline">👉【点此授权】</a></strong>`,
            })
            // 获取到 后台的 json 信息, 转移到
          } else {
            this.$message.warning(errmsg)
          }
          this.loading = false
        })
    },

    // 淘宝万宁订单 及 分页
    getTbwBookingList() {
      // 参数：当前页码：page_no、  每个页面的 数量：page_size
      // /list/flypig?page_no=1&page_size=4
      this.loading = true
      this.$http
        .get(
          `/booking/tbw_booking_list?ota_no=${this.inputOtaNum}&query=${this.query}&p_no=${this.pagenum}&p_size=${this.pagesize}`
        )
        .then((res) => {
          // 解构
          const { data, total, errno, errmsg } = res.data

          if (errno === '0') {
            this.tbwBookingListData = data.data
            this.total_ota_tbw = data.total
          } else if (errno == '4101') {
            this.$router.push({ path: '/login' })
            this.$message.warning(errmsg)
          } else if (errno == '4102') {
            // 飞猪授权通知
            this.$notify.error({
              title: '集市宝授权已过期',
              duration: 0,
              dangerouslyUseHTMLString: true,
              message: `<strong>点击获取授权：<a href="https://www.jishibao.top/#/dashboard
" style="color: blue；text-decoration:underline">👉【点此授权】</a></strong>`,
            })
            // 获取到 后台的 json 信息, 转移到
          } else {
            this.$message.warning(errmsg)
          }
          this.loading = false
        })
    },
    handlePageChange_ota_tbw(val) {
      // 参数：当前页码：page_no、  每个页面的 数量：page_size
      // /list/flypig?page_no=1&page_size=4
      this.loading = true
      this.$http
        .get(
          `/booking/tbw_booking_list?ota_no=${this.inputOtaNum}&query=${this.query}&p_no=${val}&p_size=${this.pagesize}`
        )
        .then((res) => {
          // 解构
          const { data, total, errno, errmsg } = res.data

          if (errno === '0') {
            this.tbwBookingListData = data.data
            this.total_ota_tbw = data.total
          } else if (errno == '4101') {
            this.$router.push({ path: '/login' })
            this.$message.warning(errmsg)
          } else if (errno == '4102') {
            // 飞猪授权通知
            this.$notify.error({
              title: '集市宝授权已过期',
              duration: 0,
              dangerouslyUseHTMLString: true,
              message: `<strong>点击获取授权：<a href="https://www.jishibao.top/#/dashboard
" style="color: blue；text-decoration:underline">👉【点此授权】</a></strong>`,
            })
            // 获取到 后台的 json 信息, 转移到
          } else {
            this.$message.warning(errmsg)
          }
          this.loading = false
        })
    },

    // 淘宝大东海订单 及 分页
    getTbdBookingList() {
      // 参数：当前页码：page_no、  每个页面的 数量：page_size
      // /list/flypig?page_no=1&page_size=4
      this.loading = true
      this.$http
        .get(
          `/booking/tbd_booking_list?ota_no=${this.inputOtaNum}&query=${this.query}&p_no=${this.pagenum}&p_size=${this.pagesize}`
        )
        .then((res) => {
          // 解构
          const { data, errno, errmsg } = res.data
          if (errno === '0') {
            this.tbdBookingListData = data.data
            this.total_ota = data.total
          } else if (errno == '4101') {
            this.$router.push({ path: '/login' })
            this.$message.warning(errmsg)
          } else if (errno == '4102') {
            // 飞猪授权通知
            this.$notify.error({
              title: '集市宝授权已过期',
              duration: 0,
              dangerouslyUseHTMLString: true,
              message: `<strong>点击获取授权：<a href="https://www.jishibao.top/#/dashboard
" style="color: blue；text-decoration:underline">👉【点此授权】</a></strong>`,
            })
            // 获取到 后台的 json 信息, 转移到
          } else if (errno == '4500') {
            // 飞猪授权通知
            this.$notify.error({
              title: '集市宝授权已过期',
              duration: 0,
              dangerouslyUseHTMLString: true,
              message: `<strong>点击获取授权：<a href="https://www.jishibao.top/#/dashboard
" style="color: blue；text-decoration:underline">👉【点此授权】</a></strong>`,
            })
            // 获取到 后台的 json 信息, 转移到
          } else {
            this.$message.warning(errmsg)
          }
          this.loading = false
        })
    },
    handlePageChange_ota_tbd(val) {
      // 参数：当前页码：page_no、  每个页面的 数量：page_size
      // /list/flypig?page_no=1&page_size=4
      this.loading = true
      this.$http
        .get(
          `/booking/tbd_booking_list?ota_no=${this.inputOtaNum}&query=${this.query}&p_no=${val}&p_size=${this.pagesize}`
        )
        .then((res) => {
          // 解构
          const { data, total, errno, errmsg } = res.data
          if (errno === '0') {
            this.tbdBookingListData = data.data
            this.total_ota_tbd = data.total
          } else if (errno == '4101') {
            this.$router.push({ path: '/login' })
            this.$message.warning(errmsg)
          } else if (errno == '4102') {
            // 飞猪授权通知
            this.$notify.error({
              title: '集市宝授权已过期',
              duration: 0,
              dangerouslyUseHTMLString: true,
              message: `<strong>点击获取授权：<a href="https://www.jishibao.top/#/dashboard
" style="color: blue；text-decoration:underline">👉【点此授权】</a></strong>`,
            })
            // 获取到 后台的 json 信息, 转移到
          } else if (errno == '4500') {
            // 飞猪授权通知
            this.$notify.error({
              title: '集市宝授权已过期',
              duration: 0,
              dangerouslyUseHTMLString: true,
              message: `<strong>点击获取授权：<a href="https://www.jishibao.top/#/dashboard
" style="color: blue；text-decoration:underline">👉【点此授权】</a></strong>`,
            })
            // 获取到 后台的 json 信息, 转移到
          } else {
            this.$message.warning(errmsg)
          }
          this.loading = false
        })
    },

    //  -----------------------------------  抽屉与对话框方法  --------------------------------------
    // 确认单 table的样式
    voucherStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 0) {
        return 'background:#F8F8F8;'
      }
    },
    // 确认单 - 抽屉开关,获取点击的 那个数据的 订单编号
    getVoucher(value) {
      this.dealWithBookingNum = value
      this.drawerVoucher = true
      if (value == null) {
        this.voucherHeader =
          "<p><img src='http://szsxtravel.top/voucher_booking_hearder.png'></p>"
        this.voucherData = null
        // console.log("没有");
      } else {
        this.$http.get(`/booking/booking_voucher?id=${value}`).then((res) => {
          console.log(res)
          const {
            data,
            errno,
            errmsg,
            header_introduce,
            operator,
            footer_introduce,
            refund_info,
            poi_info,
            re_mark,
          } = res.data
          if (errno == '0') {
            this.voucherHeader = header_introduce
            this.voucherData = data
            this.operator = operator
            this.voucherFooter = footer_introduce
            this.refundInfo = refund_info
            this.poi_info = poi_info
            this.re_mark = re_mark
            if (poi_info) {
              // 定位链接 http://192.168.50.243:8081/#/pagesTraver/tools/showBookingLocation?latitude=18.6272340000000&longitude=110.2174960000000&scale=18
              this.qrCode = `http://starsurfer.club/#/pagesTraver/tools/showBookingLocation?latitude=${poi_info.lat}&longitude=${poi_info.lng}&scale=18`
            }
            this.getConfirmInfor()
          } else if (errno == '4102') {
            this.$notify.error({
              title: '飞猪授权已过期',
              duration: 0,
              dangerouslyUseHTMLString: true,
              message: `<strong>点击获取授权：<a href="https://oauth.taobao.com/authorize?response_type=code&client_id=29468970&redirect_uri=${this.current_ip}booking/auth&view=web
" style="color: blue；text-decoration:underline">👉【点此授权】</a></strong>`,
            })
          } else {
            this.$message.warning(errmsg)
          }
        })
      }
    },

    // 订单详情 - 抽屉开关：获取点击的 那个数据的 订单编号,并打开抽屉,console.log(datainfo, open);
    openDrawer(datainfo, open) {
      this.$router.push({ path: '/booking_detail' })
      this.get_no = datainfo
      // console.log((this.get_no = datainfo));
    },

    // ---------------------------------------  修改订单按钮  -----------------------------
    reviseSysBooking(value) {
      let api = 'booking_id'
      this.$refs.reviseResveration.loading = true
      this.showReviseBookingDialog = true
      // 填充表单:发送请求获取ota订单信息，2参数
      if (value.sku_id) {
        this.getProductInforBookingId(value.booking_no, value.sku_id).then(
          () => {
            this.getBookingInformation(value.booking_no, api).then(() => {
              this.$refs.reviseResveration.loading = false
            })
          }
        )
      } else {
        this.getBookingInformation(value.booking_no, api).then(() => {
          this.$refs.reviseResveration.loading = false
        })
      }
      // 数据更新完毕，打开对话框
    },
    reviseOtaBooking(item) {
      //修改飞猪订单
      //console.log(item); // 平台订单信息 列表中选择的订单信息
      // return;
      this.$refs.reviseResveration.loading = true
      this.showReviseBookingDialog = true
      let api = item.ota_api_id
      if (item.outer_sku_id) {
        // 发送请求，看看有没有模版可以返回，参考product_list
        this.getProductInfor(item.outer_sku_id).then(() => {
          this.getBookingInformation(item.ota_id, api).then(() => {
            this.$refs.reviseResveration.loading = false
          })
        })
      }
      // 产品未入库：是否有outer_sku_id 及 outer_sku_id 是否有值
      else {
        // 填充表单:  发送请求获取ota订单信息，2参数
        if (item.sku_id) {
          this.getProductInforBookingId(item.id, item.sku_id).then(() => {
            this.getBookingInformation(item.ota_id, api).then(() => {
              this.$refs.reviseResveration.loading = false
            })
          })
        } else {
          this.getBookingInformation(item.ota_id, api).then(() => {
            this.$refs.reviseResveration.loading = false
          })
        }
        // 数据更新完毕，打开对话框
      }
    },
    // 关闭对话框后
    closedReviseBookingDialog() {
      if (this.activeName == 'first') {
        this.handlePageChange_system(
          this.$refs.booking_list_template.pagenum_system
        )
      } else if (this.activeName == 'second') {
        this.handlePageChange_ota_flypig(
          this.$refs.fly_booking_list_template.pagenum_system
        )
      } else if (this.activeName == 'threed') {
        this.handlePageChange_ota_tbw(
          this.$refs.tbw_booking_list_template.pagenum_system
        )
      } else if (this.activeName == 'fourth') {
        this.handlePageChange_ota_tbd(
          this.$refs.tbd_booking_list_template.pagenum_system
        )
      }
    },

    // ---------------------------------------  处理订单 （删除和预定）  -----------------------------
    // 处理系统订单按钮
    dealWithSysBooking(value) {
      // console.log(value);
      this.dialogDealwithBooking = true
      this.dealWithBookingNum = value.booking_no
      this.getFormedBookingInfo()
    },
    // 通过不同渠道处理订单，需要执行保存订单的操作。
    dealWithBooking(value) {
      // console.log(value);  若未入库，仅能获取到 平台id
      if (value.id == null) {
        this.$notify({
          title: '警告',
          message: '该订单还未入库，请先入库',
          type: 'warning',
        })
      } else {
        this.dialogDealwithBooking = true
        this.dealWithBookingNum = value.id
        this.getFormedBookingInfo()
      }
    },
    // 删除订单
    submitDeleteAndComment() {
      this.$http
        .delete(
          `/booking/delete?bookingID=${this.dealWithBookingNum}&comment=${this.deleteReasion}`
        )
        .then((res) => {
          // console.log(res)
          if (res.data.errno == '0') {
            this.visibleDelete = false
            this.dialogDealwithBooking = false
            this.$message({
              message: '全部订单中，已删除此订单',
              type: 'success',
            })
          }
        })
    },
    // 复制订单信息，获取订单信息，放到剪贴板，提示成功
    copyInfor() {
      // 修改订单状态，booking_id
      // console.log("改状态");
      this.$http.post('/booking/status', {
        status: 'CONFIRM',
        booking_id: this.dealWithBookingNum,
        ota_id: '',
      })
      this.copyText()
    },
    copyConfirmation() {
      this.$copyText(this.confirmation)
        .then((res) => {
          this.$message({
            message: '该订单信息已复制到剪贴板',
            type: 'success',
          })
          this.confirmation = ''
          // console.log("成功");
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 复制信息
    copyText() {
      this.$copyText(this.information)
        .then((res) => {
          this.$message({
            message: '该订单信息已复制到剪贴板',
            type: 'success',
          })
          this.information = ''
          // console.log("成功");
        })
        .catch((err) => {
          console.log(err)
        })
    },

    // 获取 确认信息
    getConfirmInfor() {
      this.$http
        .get(`/booking/detail?booking_id=${this.dealWithBookingNum}`)
        .then((res) => {
          const { data, errmsg, errno } = res.data
          if (errno == '0') {
            // console.log("进入promise");
            // 订单编号
            let information_id = '订单编号：' + data.about_booking.ota_id + '\n'
            // 出行日期
            let information_date =
              '出行日期：' + data.about_booking.trip_start_date + '\n'
            // 套餐名称
            let information_title =
              '套餐名称：' + data.about_booking.sku_name + '\n'
            // 场次
            let information_time =
              '场次/时间：' +
              this.checkEmpty(data.about_booking.start_time) +
              '\n'

            // 判断 订单信息 是否为空 -》 处理订单信息
            let pick_is_null = this.checkEmpty(
              data.about_booking.additional_info
            )
            let addition_info = ''
            if (pick_is_null) {
              let addition_list = []
              pick_is_null.forEach((item, index) => {
                let i = item.name + '：' + item.value + '\n'
                addition_list.push(i)
              })
              addition_info = addition_list.join('')
            } else {
              addition_info = ''
            }

            // 判断人数是否为空 -》 处理人数
            let information_num = this.checkEmpty(data.about_booking.num)
            let num_list = []
            information_num.forEach((item, index) => {
              let i = item.type + '：' + item.num + '\n'
              num_list.push(i)
            })
            let num_info = num_list.join('')

            // 判断附加项是否为空 -》 处理 附加项
            let select_addition_dict = this.checkEmpty(
              data.about_booking.select_addition_dict
            )
            let select_addition_info = ''
            if (select_addition_dict) {
              let select_addition_list = []
              select_addition_dict.forEach((item, index) => {
                let i = item.addition_name + '：' + item.addition_num + '\n'
                select_addition_list.push(i)
              })
              select_addition_info =
                '------附加项------' + '\n' + select_addition_list.join('')
            } else {
              select_addition_info = ''
            }

            // 联系人
            let information_other =
              '联系人姓名：' +
              data.about_contact.name +
              '\n' +
              '联系电话：' +
              data.about_contact.mobile +
              '\n'
            // // 出行人信息：
            // let information_travellers =
            //   "--------" + "\n" + "出行人信息：" + "\n";
            // data.travellers.forEach((i, index) => {
            //   if (i.traveller_name_en == null) {
            //     information_travellers =
            //       information_travellers + i.traveller_name;
            //   } else {
            //     information_travellers =
            //       information_travellers +
            //       i.traveller_name +
            //       i.traveller_name_en;
            //   }

            //   i.credential.forEach((item, index) => {
            //     if (item.credential != null) {
            //       information_travellers =
            //         information_travellers +
            //         "\n" +
            //         item.credential +
            //         ":" +
            //         item.credentialNum +
            //         "\n";
            //     }
            //   });
            // });

            // 汇总
            let information =
              '您好，您的行程已确认' +
              '\n' +
              '到店后报姓名 、电话即可:' +
              '\n' +
              '\n' +
              information_id +
              information_date +
              information_title +
              information_time +
              num_info +
              information_other +
              addition_info +
              select_addition_info

            // 获取确认单信息
            let a = document.getElementsByClassName('voucher-footer')
            let confirm_infor = a[0].innerText
            this.confirmation = information + confirm_infor
            //
          } else if (errno == '4002') {
            this.$notify({
              title: '警告',
              message: '该订单还未入库，请先入库',
              type: 'warning',
            })
          }
        })
    },
    // ---------------------------------------  选择订单出行人  -----------------------------
    selectBookingTraveller(value) {
      // console.log(value); // value 是 系统订单编号
      this.$refs.select_add_traveller.booking_no = value
      this.$http
        .get(`/booking/get_all_travellers?booking_id=${value}`)
        .then((res) => {
          const { data, errno, errmsg } = res.data
          if (errno == '0') {
            this.traveller_data = data
            this.showSelectTraveller = !this.showSelectTraveller
          } else {
            this.$notify.error({
              title: '错误',
              message: errmsg,
            })
          }
        })
    },
    reviseCancle() {
      this.dialogReviseBooking = false
    },
    //
  },
}
</script>

<style>
.box-search-card {
  height: auto;
  margin-bottom: 5px;
}

.booking-header {
  height: 70px;
}

.booking-search {
  display: flex;
  float: right;
}

.booking-wait-accept {
  /* font-size: 1rem; */
  font-weight: bolder;
  display: flex;
  float: right;
  /* color: limegreen; */
}

.booking-change-booking {
  /* font-size: 1rem; */
  font-weight: bolder;
  display: flex;
  float: right;
  /* color: mediumblue; */
}

.booking-search button {
  margin-left: 10px;
}

.pagination {
  position: flex;
  float: right;
  margin-top: 10px;
}

.el-drawer__body {
  overflow: auto;
  /* 在Drawer 抽屉增加高度过窄自动加滚动条功能 */
}

.no-data-voucher {
  /* 无数据显示 */
  text-align: center;
  margin-top: 50%;
  margin-bottom: 50%;
}

.v-header {
  width: 95%;
  margin: auto;
  margin-bottom: 30px;
  padding-top: 10px;
}

.v-header img {
  width: 100%;
}

.voucher-footer {
  width: 90%;
  border: 1px solid #cac9c9;
  padding: 15px;
  margin: 0px auto;
}

.voucher-footer img {
  width: 100%;
}

.footer-title {
  width: 90%;
  border: 1px solid #fab099;
  color: #ffffff;
  background-color: #fab099;
  padding: 3px 15px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
  text-align: center;
  font-size: large;
  font-weight: 900;
}

.drawer-voucher-footer-button {
  padding-top: 10px;
  text-align: center;
  background-color: tomato;
  height: 50px;
  position: fixed;
  width: 40%;
  bottom: 0;
  left: 0;
  right: 0;
}

/* 下单的对话框 圆角矩形*/
.el-dialog {
  border-radius: 10px;
}

.copy-button {
  margin: 15px 15px 0;
  text-align: right;
}

.el-table_1_column_2 {
  padding: 0px;
}

.testdiv {
  margin-left: 5px;
}

/* 筛选框样式 */
.booking-header-system {
  height: auto;
}

.booking-filter-area {
  margin-bottom: 10px;
}

#operator-info-area-triangle {
  float: right;
  width: 0;
  height: 0;
  border-top: 20px solid #ff5421;
  border-left: 20px solid transparent;
}

.choice_show_area {
  cursor: pointer;
  white-space: pre-wrap;
}

#operator-info-area {
  float: right;
  padding-left: 10px;
  color: whitesmoke;
  width: 150px;
  height: 20px;
  background-color: #ff5421;
}
</style>